import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
export const ButtonArchive = forwardRef(function ButtonArchive(props, ref) {
  const {
    t
  } = useTranslation('common');
  return <Button color="delete" data-testid="button-archive" {...props} ref={ref}>
			{props.children || t('buttons.archive')}
		</Button>;
});